export default "__VITE_ASSET__CT0eia0w__"